import { ModelAPI, ApiFilter } from '@thinknimble/tn-models'
import { apiErrorHandler } from '@/services/api'
import { apiClient } from '../client'

export default class FundAPI extends ModelAPI {
  static ENDPOINT = '/contentful/funds/'
  get client() {
    return apiClient()
  }
  async list({ filters = {}, pagination = {} }) {
    const options = {
      params: ApiFilter.buildParams(FundAPI.FILTERS_MAP, {
        ...filters,
      }),
    }

    try {
      const res = await this.client.get(FundAPI.ENDPOINT, options)
      return {
        ...res.data,
        results: res.data.results.map(i => this.cls.fromAPI(i)),
      }
    } catch (e) {
      apiErrorHandler({ apiName: 'Error retrieving funds' })(e)
    }
  }
  async retrieve(id) {
    try {
      const res = await this.client.get(`${FundAPI.ENDPOINT}${id}/`)
      return this.cls.create(this.cls.fromAPI(res.data))
    } catch (e) {
      apiErrorHandler({ apiName: 'Failed to retrieve fund', rethrowErrors: true })
    }
  }
}
export class FundMetricAPI extends ModelAPI {
  static ENDPOINT = '/contentful/fundMetrics/'
  static FILTERS_MAP = {
    ...FundMetricAPI.FILTERS_MAP,
    fund: ApiFilter.create({ key: 'fund' }),
    order: ApiFilter.create({ key: 'order' }),
  }

  get client() {
    return apiClient()
  }
  async list({ filters = {}, pagination = {} }) {
    const options = {
      params: ApiFilter.buildParams(FundMetricAPI.FILTERS_MAP, {
        ...filters,
      }),
    }

    try {
      const res = await this.client.get(FundMetricAPI.ENDPOINT, options)
      return {
        ...res.data,
        results: res.data.results.map(i => this.cls.fromAPI(i)),
      }
    } catch (e) {
      apiErrorHandler({ apiName: 'Error retrieving fund metrics' })(e)
    }
  }
}
